import type { StatusDotColor } from './StatusDot';

/** Relative time string. `now` is injectable for deterministic tests. */
export function formatTimeAgo(date: Date | string, now: Date = new Date()): string {
  const then = typeof date === 'string' ? new Date(date) : date;
  const sec = Math.floor((now.getTime() - then.getTime()) / 1000);
  if (sec < 60) return 'just now';
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.floor(hr / 24);
  return `${day}d ago`;
}

/** Relative countdown string ("in 1h 23m"). `now` is injectable for deterministic tests. */
export function formatTimeUntil(date: Date | string, now: Date = new Date()): string {
  const then = typeof date === 'string' ? new Date(date) : date;
  const min = Math.floor((then.getTime() - now.getTime()) / 60000);
  if (min <= 0) return 'now';
  if (min < 60) return `in ${min}m`;
  const hr = Math.floor(min / 60);
  if (hr < 24) {
    const rem = min % 60;
    return rem > 0 ? `in ${hr}h ${rem}m` : `in ${hr}h`;
  }
  const day = Math.floor(hr / 24);
  return `in ${day}d`;
}

export const DEFAULT_STALE_MS = 15 * 60 * 1000;

/** green while fresh, yellow once age exceeds the stale threshold. */
export function freshnessColor(ageMs: number, staleAfterMs: number = DEFAULT_STALE_MS): StatusDotColor {
  return ageMs > staleAfterMs ? 'yellow' : 'green';
}
